import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface TerminalSimulatorOverlayData {
  amount: number;
}

export type TerminalSimulatorResult = 'APPROVED' | 'DECLINED' | 'CANCELED';

@Component({
  selector: 'app-terminal-simulator-overlay',
  templateUrl: './terminal-simulator-overlay.component.html',
  styleUrls: ['./terminal-simulator-overlay.component.css'],
})
export class TerminalSimulatorOverlayComponent {
  amount = 0;

  constructor(
    public dialogRef: MatDialogRef<
      TerminalSimulatorOverlayComponent,
      TerminalSimulatorResult | undefined
    >,
    @Inject(MAT_DIALOG_DATA) public data: TerminalSimulatorOverlayData
  ) {
    this.amount = Number(data?.amount) || 0;
  }

  formatMoney(value: number): string {
    return (Number(value) || 0).toFixed(2);
  }

  approve(): void {
    this.close('APPROVED');
  }

  decline(): void {
    this.close('DECLINED');
  }

  cancel(): void {
    this.close('CANCELED');
  }

  private close(result: TerminalSimulatorResult): void {
    this.dialogRef.close(result);
  }
}
